import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo21Y22RMF2026SistemasDeMedicion() {
  return <CategoryPage category="anexo21Y22Rmf2026SistemasDeMedicion" pageTitle="Sistemas De Medicion 2026" />;
}

export default Anexo21Y22RMF2026SistemasDeMedicion;
